

















import { Component, Watch, Vue } from 'vue-property-decorator';
import { State, Getter, Mutation} from 'vuex-class';
import { FunctionsState } from '../stores/functions/types';
import { Functions, Function, Post } from '../Classes/Entities';
import { TaskContent } from '../Classes/Entities/Chat/TaskContent';
import TalkThreadOverview from '../components/talk/TalkThreadOverview.vue';
import TalkThreadForm from '../components/talk/TalkThreadForm.vue';

const namespace: string = 'functions';

@Component({
  components: {
    TalkThreadOverview,
    TalkThreadForm
  },
})
export default class Talk extends Vue {
  @State('functions') 
  public functions!: FunctionsState;

  @Getter('functionMap', { namespace }) 
  public functionMap!: Functions;

  @Mutation('getKeys', { namespace }) 
  public getKeys!: any;

  private _task!: Post;

  public get functionId():string{
    return this.$route.params.function_id;
  }

  public get task():Post {
    const taskId:string = this.$route.params.task_id;
    const functionId:string = this.$route.params.function_id;
    const func:Function<Post> = this.functionMap.get(functionId);
    const task:Post  = func.postList.get(taskId);
    this._task = task;

    return this._task;
  }
}
